import React from "react";

export const LoadingSection = React.forwardRef(({ message }, ref) => {
  return (
    <div className={"info-box"}>
      <p>{message || "Details Loading... Please Wait"}</p>
    </div>
  );
});
